export const settingsPagination = {
    size: 10,
    sort: "insertData"
}

export const settingsPaginationNotification = {
    size: 5,
    sort: "notificationId"
}

export const settingsPaginationInsertDataDesc = {
    size: 10,
    sort: "insertData",
    direction: "desc"
}


export const settingsPaginationInsertDataAsc = {
    size: 10,
    sort: "insertData",
    direction: "asc"
}

export const settingsPaginationSalaryDesc = {
    size: 10,
    sort: "salary",
    direction: "desc"
}

export const settingsPaginationSalaryAsc = {
    size: 10,
    sort: "salary",
    direction: "asc"
}

export const settingsPaginationRolesAvailableAsc = {
    size: 10,
    sort: "numberRoles",
    direction: "asc"
}

export const settingsPaginationRolesAvailableDesc = {
    size: 10,
    sort: "numberRoles",
    direction: "desc"
}

export const settingsPaginationUserTalent = {
    size: 5,
    sort: "id"
}

export const notificationType = {
  login: {
    notificationName: "You have logged in",
    notificationType: "LOGIN"
  },
  addJob: {
    notificationName: "You added a job",
    notificationType: "ADD_JOB"
  },
  addSeekingJob: {
    notificationName: "You added a seeking job",
    notificationType: "ADD_SEEKING_JOB"
  },
  editJob: {
    notificationName: "You edited a job",
    notificationType: "EDIT_JOB"
  },
  editSeekingJob: {
    notificationName: "You edited a seeking job",
    notificationType: "EDIT_SEEKING_JOB"
  },
  deleteJob: {
    notificationName: "You deleted a job",
    notificationType: "DELETE_JOB"
  },
  deleteSeekingJob: {
    notificationName: "You deleted a seeking job",
    notificationType: "DELETE_SEEKING_JOB"
  },
  addFavourite: {
    notificationName: "You added a favourite",
    notificationType: "ADD_FAVOURITE"
  },
  deleteFavourite: {
    notificationName: "You removed a favourite",
    notificationType: "DELETE_FAVOURITE"
  },
  deleteAllFavourite: {
    notificationName: "You removed all favourites",
    notificationType: "DELETE_ALL_FAVOURITE"
  },
  deleteAllPosts: {
    notificationName: "You removed all posts",
    notificationType: "DELETE_ALL_POSTS"
  },
  deleteAllSeekingPosts: {
    notificationName: "You removed all seeking posts",
    notificationType: "DELETE_ALL_SEEKING_POSTS"
  },
  sendCandidateEmail: {
    notificationName: "You sent an email to a candidate",
    notificationType: "SEND_CANDIDATE_EMAIL"
  },
  receiptCandidateEmail: {
    notificationName: "You received an email from a candidate",
    notificationType: "RECEIPT_CANDIDATE_EMAIL"
  }
};
